import { Link, NavLink } from "react-router-dom";
import React, { useState } from "react";
import { close_beta, hamburger_beta } from "assets";

import Logo from "components/global/Logo";
import styled from "styled-components";
import { useHistory } from "react-router-dom"
import { useScrollPosition } from "react-use-scroll-position";
import Button from "components/global/Button";

const Wrapper = styled.div`
  &.white {
    background-color: white;
    box-shadow: inset 0px -1px 0px #eaeaea;
  }

  position: fixed;
  z-index: 50;
  top: 0;
  width: 100%;

  .constrain {
    display: flex;
    align-items: center;
    height: 9.5rem;
    margin: auto;
    max-width: 124.8rem;
  }
  .button-container {
    margin-left: auto;
    gap: 24px;
    @media (max-width: 768px) {
      display: none;
    }
  }
  .login-btn {
    color: var(--primary);
    font-size: 1.8rem;
    transition: all 250ms;
    border: 1px solid var(--primary);
    height: 4.8rem;
    width: 105px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    &:hover {
      color: white;
      background-color: var(--primary_light);
      border-color: var(--primary_light);
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  .main-nav {
    display: flex;
    align-items: center;

    .first {
      margin-left: 12rem;
    }

    a:not(:first-child) {
      padding-left: 2.4rem;
      padding-right: 2.4rem;

      &:hover {
        color: var(--secondary);
        transition: ease-in 250ms;
      }

      @media (max-width: 768px) {
        display: none;
      }
    }

    .active {
      color: var(--secondary);
      font-weight: 700;
    }
  }

  // MOBILE
  .mb {
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }

  .toggler {
    @media (max-width: 768px) {
      display: flex;
      position: relative;
      margin-left: auto;
      margin-right: 2.4rem;
      img {
        position: absolute;
      }
    }
  }

  .hide {
    opacity: 0;
  }
`;

const MobileNav = styled.div`
  display: none;
  @media (max-width: 768px) {
    overflow: hidden;
    height: 0;
    opacity: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    top: 9.4rem;
    position: fixed;
    z-index: 50;
    width: 100%;
    background-color: white;
    padding: 2.4rem;
    font-size: 1.8rem;
    line-height: 2.4rem;
    transition: all 250ms;
    a {
      padding: 1.2rem;
    }

    .active {
      font-weight: 700;
      color: var(--secondary);
    }

    &.show {
      height: calc(100vh - 9.4rem);
      opacity: 1;
    }
  }

  .button-container {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

const Nav = () => {
  const router = useHistory();
  const { y } = useScrollPosition();
  const [willShow, setWillShow] = useState(false);
  return (
    <>
      <Wrapper
        className={`outer-most-container nav ${y !== 0 ? "white" : ""} ${willShow && "white"
          }`}
      >
        <div className="constrain">
          <div className="main-nav">
            <Link to="/home">
              <Logo />
            </Link>
            <a
              className="first"
              activeClassName="active"
              href="http://blog.postpaddy.com/"
            >
              Blog
            </a>
            <a
              activeClassName="active"
              href="https://blog.postpaddy.com/resources/"
            >
              Resources
            </a>
            <NavLink activeClassName="active" to="/faqs">
              FAQs
            </NavLink>
          </div>

          <div className="flexRow button-container">
            <button
              onClick={() => router.push("/sign-in")}
              className="login-btn"
            >
              Login
            </button>

            <Button text="Try for free" width="147px" onClick={()=> router.push("/sign-up")}/>
          </div>

          {/* MOBILE */}
          <button onClick={() => setWillShow(!willShow)} className="toggler mb">
            <img
              src={close_beta}
              alt="close_beta"
              className={`${!willShow && "hide"}`}
            />
            <img
              src={hamburger_beta}
              alt="hamburger_beta"
              className={`${willShow && "hide"}`}
            />
          </button>
        </div>
      </Wrapper>

      <MobileNav className={willShow ? "show" : ""}>
        <a className="first mb" href="http://blog.postpaddy.com/">
          Blog
        </a>
        <a href="https://blog.postpaddy.com/resources/">Resources</a>
        <NavLink activeClassName="active" to="/faqs">
          FAQs
        </NavLink>

        <div className="button-container">
          <Button text="Login" onClick={()=> router.push("/sign-in")} width="100%" className="bordered" />
          <Button text="Try for free" onClick={()=> router.push("/sign-up")} width="100%" />
        </div>
      </MobileNav>
    </>
  );
};

export default Nav;
